// componentImports.js

import FullFormatVerse from '../Components/FullFormatVerse';
import Book from '../Components/Book';
import Stack1 from '../Components/Stack1';
import NoteVerseList from '../Components/NoteVerseList';
import Chapter from '../Components/Chapter';
import Dialog1 from '../Components/Dialog1';
import Dialog2 from '../Components/Dialog2';
import Dialog3 from '../Components/Dialog3';
import Dialog4 from '../Components/Dialog4';
import Tab1 from '../Components/Tab1';
import Navbar from '../Components/Navbar';
import VerseSearch from '../Components/VerseSearch';
import Verse from '../Components/Verse';
import NoteBookmarkList from '../Components/NoteBookmarkList';
import NoteBookmarkListItem from '../Components/NoteBookmarkListItem';
import VerseLabelArrows4Result from '../Components/VerseLabelArrows4Result';
import ConfirmationDialog from '../Components/ConfirmationDialog';
import Accordion1 from '../Components/Accordion1';
import ChipArray from '../Components/ChipArray';
import SearchResult from '../Components/SearchResult';
import ForgotPassword from '../Components/PasswordReset';
import ClipLoader1 from '../Components/ClipLoader1';
import VerseLabelArrows from '../Components/VerseLabelArrows';
import Switch1 from '../Components/Switch1';
import Selection from '../Components/Selection';
import Test from '../Components/Test';
import Profile from '../Components/Profile';
import UserListItem from '../Components/UserListItem';
// import SystemConfig from '../Components/SystemConfigTemp';
// import UserProfile from '../Components/UserProfileTemp';
// import Profile3 from '../Components/Profile3Temp';
import AddChangeNote from '../Components/AddChangeNote';
import History from '../Components/History';
import Profile4Personal from '../Components/Profile4Personal';
import Profile4System from '../Components/Profile4System';
import SignUpEmailSent from '../Components/SignUpEmailSent';

export default { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem }